import React from 'react';
import { render, fireEvent } from '@testing-library/react';

import CheckYourEmail from './CheckYourEmail';

jest.mock('@decisiv/breakpoint-observer', () => ({
  __esModule: true,
  default: ({ children }) => children({ observedElementRef: null }),
  sizes: { SM: 'SM', MD: 'MD' },
}));
jest.mock('@decisiv/ui-components', () => ({
  Badge: () => null,
  H2: ({ children }) => <h2>{children}</h2>,
}));
jest.mock('@decisiv/ui-components/lib/components/Typography', () => ({
  P: ({ children }) => <p>{children}</p>,
}));
jest.mock(
  '@decisiv/ui-components/lib/components/Button',
  () => ({ text, onClick }) => (
    <button type="button" onClick={onClick}>
      {text}
    </button>
  ),
);
jest.mock('@decisiv/iconix/lib/components/Envelope', () => () => null);

const translations = {
  checkYourEmailTitle: 'Check your email',
  checkYourEmailInstructions: 'We have sent you an email with a link.',
  backToLogin: 'Back to Login',
};

describe('CheckYourEmail', () => {
  it('renders the title and instructions from the translations prop', () => {
    const page = render(<CheckYourEmail translations={translations} />);

    expect(page.getByText('Check your email')).toBeTruthy();
    expect(
      page.getByText('We have sent you an email with a link.'),
    ).toBeTruthy();
  });

  it('invokes the back callback when the back button is activated', () => {
    const backLoginClick = jest.fn();
    const page = render(
      <CheckYourEmail
        translations={translations}
        backLoginClick={backLoginClick}
      />,
    );

    fireEvent.click(page.getByText('Back to Login'));

    expect(backLoginClick).toHaveBeenCalled();
  });

  it('renders no hardcoded user-facing copy when translations are absent', () => {
    const page = render(<CheckYourEmail />);

    expect(page.queryByText('Check your email')).toBeNull();
    expect(page.queryByText(/sent you an email/)).toBeNull();
  });

  it('omits the heading and paragraph entirely rather than rendering them empty', () => {
    const { container } = render(<CheckYourEmail />);

    expect(container.querySelector('h2')).toBeNull();
    expect(container.querySelector('p')).toBeNull();
  });
});
